import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';

import { take } from 'rxjs/operators';

import { AuthService } from '@auth/services';

@Component({
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundComponent {
  constructor(public authService: AuthService, private router: Router) {}

  goBack() {
    this.authService.screens$.pipe(take(1)).subscribe((screens) => {
      void this.router.navigate([screens?.currentScreen?.route ?? 'home']);
    });
  }

  goHome() {
    void this.router.navigate(['home']);
  }
}
